import {color_white} from "../../../../constants/colors";

export const styles = {
    dataUpdatingContainer: {
        padding: "20px 0",
        backgroundColor: color_white,
        borderRadius: 20,
        width: 530,
        height: "max-content",
    },
    dataUpdatingForm: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly",
        gap: 20
    }
}